import { PagedResult } from './pagedResults';
import { PagedDataResults } from './pagedDataResults';

export function pagedDataGenerator<T extends PagedResult>(results: PagedDataResults<T>, page: any, data: Array<T>, skipResults: number): T[] {
  let fetched: T[];
  if (page.includeCount) {
    fetched = new Array<T>(results.totalCount);
    for (let i = 0; i < results.totalCount; i++) fetched[i] = { recordIndex: i } as T;
  } else {
    fetched = [...data];
  }

  // const fetched = !page.includeCount ?
  //     [...data] :
  //     new Array(totalCount)
  //         .fill({})
  //         .map<T>((item, i) => {
  //             return {recordIndex: i} as T;
  //         });

  results.data.forEach((res, index) => {
    let dataIndex = index + skipResults;
    fetched[dataIndex] = { ...res, recordIndex: dataIndex };
  });

  return fetched;
}

export function pagedFetchRequired(page: any, data: any[], checkField?: string) {
  const field = checkField || 'id';
  for (let i = page.skip; i < page.skip + page.take && i < data.length; i++) {
    if (data[i][field] === undefined) return true;
  }
  return false;
}

export function skipPagedResults(page: any) {
  return Math.max(page.skip - page.take, 0);
}